import { UtilsService } from 'src/app/services/utils.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { fromCandidateSearch } from '../reducers/candidate-search.reducer';
import { Pagination } from '../models/pagination.model';
import { Candidate, CandidateCreate } from '../models/candidate.model';
import { AppConfig } from '../helpers/app.config';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

  constructor(
    private store: Store,
    private httpClient: HttpClient,
    private utilsService: UtilsService) { }

  search(page: number, officeId: number, clientId: number): Observable<Pagination<Candidate>> {

    if (page === undefined) {
      page = 1;
    }

    return this.store.pipe(select(fromCandidateSearch.selectCandidateSearchState), switchMap(candidateSearch => {
      const cleanCandidateSearch = {};
      for (const key in candidateSearch) {
        if (candidateSearch[key] && key !== 'type') {
          cleanCandidateSearch[key] = candidateSearch[key];
          if (key === 'email') {
            cleanCandidateSearch[key] = encodeURIComponent(candidateSearch[key]);
          }
        }
      }
      return this.httpClient.get<Pagination<Candidate>>(AppConfig.settings.API + '/candidates?origin=ct',
        { params: { ...cleanCandidateSearch, page, officeId: officeId.toString(), clientId } as any }
      );
    }));
  }

  getByToken(token: string): Observable<Candidate> {
    return this.httpClient.get<Candidate>(AppConfig.settings.API + '/candidates/' + token + '?origin=ct').pipe(map(candidate => {
      // añadir la fecha de expiracion
      for (const invitation of candidate.invitationsLite) {
        invitation.tests = invitation.tests.sort((a, b) => this.utilsService.ADNTestModelIds.includes(a.testModelId) ? -1 : 1);
      }
      return candidate;
    }));
  }

  create(candidates: CandidateCreate[], officeId: number, clientId: number): Observable<Candidate[]> {
    return this.httpClient.post<Candidate[]>(AppConfig.settings.API + '/candidates?origin=ct', { candidates },
      { params: { officeId, clientId } as any }
    );
  }

}
